import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppButton() {
  const handleClick = (event) => {
    // URL dinámica para desarrollo y producción
    const backendUrl =
      window.location.hostname === "neuralnetadaptivecontrol.com"
        ? "https://controlbook.onrender.com"
        : "http://localhost:3000";

    // Trackear el click
    fetch(`${backendUrl}/clicks`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        sessionId: "session-" + Math.random().toString(36).substr(2, 9),
        elementId: "whatsapp-button",
        pageUrl: window.location.href,
        elementType: "link",
        userId: "user-react",
        coordinates: { x: event.clientX, y: event.clientY },
        metadata: {
          platform: "WhatsApp",
          action: "visit",
        },
      }),
    }).catch((err) => console.error("Error tracking WhatsApp click:", err));
  };

  return (
    <a
      href="https://wa.me/34699977616"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 md:left-6 md:right-auto right-6 z-50 p-3 rounded-full shadow-lg hover:scale-110 transition-transform"
      style={{ backgroundColor: "transparent" }}
      onClick={handleClick}
    >
      <FaWhatsapp size={52} color="#25D366" />
    </a>
  );
}
